import { c as _c } from "react/compiler-runtime";
import type { ItemShape } from "@sticker-giant/sg-frontend-common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { trackShapeSelected } from "@/lib/analytics/segment";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionLabel from "./OptionLabel";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
import ValidationError, { useFieldErrorId } from "./ValidationError";
export default function Shape() {
  const $ = _c(27);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const selectedShape = usePdpStore(_temp);
  const setShape = usePdpStore(_temp2);
  const clearValidationError = usePdpStore(_temp3);
  const shapeErrorId = useFieldErrorId("shape");
  const shapeControlIdBase = `shape-${product.sku}`;
  const shapeLabelId = `${shapeControlIdBase}-label`;
  const shapeHelpDialogId = `${shapeControlIdBase}-help-dialog`;
  const shapeSelectContentId = `${shapeControlIdBase}-select-content`;
  const microcopyFields = useProductMicrocopy();
  const shapeHelper = microcopyFields?.shapeHelper;
  const shapeLabel = microcopyFields?.shapeLabel ?? "Shape";
  const shapeValue = selectedShape ?? productAdmin?.defaultShape ?? "";
  if ((productAdmin?.shapeOptions.length ?? 0) <= 1) {
    return null;
  }
  let t0;
  if ($[0] !== shapeHelpDialogId || $[1] !== shapeHelper || $[2] !== shapeLabel || $[3] !== shapeLabelId) {
    t0 = <OptionLabel id={shapeLabelId} label={shapeLabel} helper={shapeHelper} helpDialogId={shapeHelpDialogId} />;
    $[0] = shapeHelpDialogId;
    $[1] = shapeHelper;
    $[2] = shapeLabel;
    $[3] = shapeLabelId;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== clearValidationError || $[6] !== setShape) {
    t1 = value => {
      const shape = value as ItemShape;
      setShape(shape);
      clearValidationError("shape");
      trackShapeSelected(shape);
    };
    $[5] = clearValidationError;
    $[6] = setShape;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SelectValue placeholder="-- Select Shape --" />;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== shapeErrorId || $[10] !== shapeLabelId || $[11] !== shapeSelectContentId) {
    t3 = <SelectTrigger aria-labelledby={shapeLabelId} aria-describedby={shapeErrorId} aria-controls={shapeSelectContentId} className="w-full">{t2}</SelectTrigger>;
    $[9] = shapeErrorId;
    $[10] = shapeLabelId;
    $[11] = shapeSelectContentId;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== productAdmin?.shapeOptions) {
    t4 = productAdmin?.shapeOptions.map(_temp4);
    $[13] = productAdmin?.shapeOptions;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== shapeSelectContentId || $[16] !== t4) {
    t5 = <SelectContent id={shapeSelectContentId}>{t4}</SelectContent>;
    $[15] = shapeSelectContentId;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== shapeValue || $[19] !== t1 || $[20] !== t3 || $[21] !== t5) {
    t6 = <Select value={shapeValue} onValueChange={t1}>{t3}{t5}</Select>;
    $[18] = shapeValue;
    $[19] = t1;
    $[20] = t3;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ValidationError field="shape" />;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t0 || $[25] !== t6) {
    t8 = <div className="flex flex-col gap-1" data-validation-field="shape">{t0}{t6}{t7}</div>;
    $[24] = t0;
    $[25] = t6;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
function _temp4(shape_0) {
  return <SelectItem key={shape_0.sku} value={shape_0.sku}>{shape_0.displayName}</SelectItem>;
}
function _temp3(state_1) {
  return state_1.clearValidationError;
}
function _temp2(state_0) {
  return state_0.setShape;
}
function _temp(state) {
  return state.shape;
}